import axios from 'axios';
import Config from 'Config';
import { createSignedRequest } from 'utils/createSignedRequest';

// Consolidated: the backend sets the given rows' status to PENDING, creates
// the approval token and sends the row-approval email in one call.
export const postSendInstalmentTableRowApproval = async (
  projectId,
  instalmentTableId,
  rowIds,
  email
) => {
  const apiPath = `invoice/${projectId}/sale-invoice-instalment-tables/${instalmentTableId}/send-row-approval`;

  const body = { rowIds, email };

  const request = {
    url: `https://${process.env.REACT_APP_WORK_CALENDAR_API_URL}/${apiPath}`,
    // url: `http://localhost:3001/${apiPath}`,
    host: process.env.REACT_APP_WORK_CALENDAR_API_URL,
    path: apiPath,
    data: body,
    body: JSON.stringify(body),
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'POST',
    region: Config.AWS_REGION,
    service: 'execute-api',
  };
  const signedRequest = await createSignedRequest(request);

  const response = await axios(signedRequest);

  return response.data;
};
